import { useMutation } from "@tanstack/vue-query";
import { examinationImageRotate } from "../core/examination";

export function useExaminationImageRotate() {
  const mutation = useMutation(examinationImageRotate());

  return mutation;
}
